import { render, staticRenderFns } from "./ClassicAntimatterDimensionsTab.vue?vue&type=template&id=77684bcf&scoped=true&"
import script from "./ClassicAntimatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ClassicAntimatterDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassicAntimatterDimensionsTab.vue?vue&type=style&index=0&id=77684bcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77684bcf",
  null
  
)

export default component.exports